<template>
  <!-- 在线商城产品列表 -->
  <div class="container">
    <div class="vue padHorizontal10">
      <div class="header flex">
        <div class="text">在线商城产品列表</div>
        <el-button @click="addShopBut" round type="primary" size="small"
          >添加在线商城产品</el-button
        >
      </div>
      <div class="content ">
        <el-table
          height="78vh"
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="ProductList"
          style="width: 100%"
        >
          <!-- 规格管理 -->
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="specs">
                <div class="title-name primaryCol padVertical10">
                  商品规格
                </div>
                <div
                  class="specs-list padVertical10 flex flexAi-c "
                  v-for="(item, index) in props.row.pointsMallUnits"
                  :key="index"
                >
                  <div class="name">ID：{{ item.id }}</div>
                  <div class="name">规格：{{ item.name }}</div>
                  <div class="name">价格：{{ item.price }}</div>
                  <div class="name">库存：{{ item.stock }}</div>
                  <div class="data-right flex flexAi-c">
                    <el-link
                      class="padR10"
                      :underline="false"
                      type="primary"
                      @click="unitEditBut(item)"
                      >编辑</el-link
                    >
                    <el-popconfirm
                      @confirm="unitDelBut(item)"
                      title="这是一段内容确定删除吗？"
                    >
                      <el-link
                        slot="reference"
                        :underline="false"
                        type="primary"
                        >删除</el-link
                      >
                    </el-popconfirm>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="ID"> </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              {{ scope.row.createtime | filterTime }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="产品名称"> </el-table-column>
          <el-table-column prop="name" label="产品图片">
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: 100px"
                :src="baseImage + scope.row.pic"
                :preview-src-list="[baseImage + scope.row.pic]"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="价格"> </el-table-column>
          <el-table-column prop="allStock" label="总库存"> </el-table-column>
          <el-table-column label="规格操作">
            <template slot-scope="scope">
              <el-link
                class="padR10"
                :underline="false"
                type="primary"
                @click="addUnitBut(scope.row)"
                >新增规格</el-link
              >
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-link
                class="padR10"
                :underline="false"
                type="primary"
                @click="editBut(scope.row)"
                >编辑</el-link
              >
              <el-popconfirm
                @confirm="delBut(scope.row)"
                title="这是一段内容确定删除吗？"
              >
                <el-link slot="reference" :underline="false" type="primary"
                  >删除</el-link
                >
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="dialog">
      <el-dialog
        @closed="dialogClosed"
        title="规格管理"
        :modal-append-to-body="false"
        :visible.sync="unitDialog"
        width="30%"
      >
        <div class="content ">
          <el-form
            :rules="rules"
            size="small"
            ref="formUnit"
            :model="formUnit"
            label-width="80px"
          >
            <el-form-item label="规格名" prop="name">
              <el-input v-model="formUnit.name"></el-input>
            </el-form-item>

            <el-form-item label="价格" prop="price">
              <el-input-number
                size="small"
                class="width100"
                :step="0.1"
                v-model="formUnit.price"
                controls-position="right"
                :min="0"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="库存" prop="stock">
              <el-input-number
                size="small"
                class="width100 "
                v-model="formUnit.stock"
                controls-position="right"
                :min="0"
              ></el-input-number>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('formUnit')"
                >确定</el-button
              >
              <el-button @click="unitDialog = false">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  apiGetGoodsList,
  apiDeleteGoods,
  apiAddPointsUnit,
  apiDelPointsUnit,
  apiEditPointsUnit
} from '@/api/ProductManage'
export default {
  name: '',
  props: [''],
  data() {
    return {
      ProductList: [],
      unitDialog: false, // 规格弹窗
      shopRow: '', // 单条数据
      unitRow: '', // 规格单条数据
      formUnit: {
        name: '',
        price: '',
        stock: ''
      },
      rules: {
        name: [{ required: true, message: '请输入规格名称', trigger: 'blur' }],
        price: [{ required: true, message: '请输入产品价格', trigger: 'blur' }],
        stock: [{ required: true, message: '请输入产品库存', trigger: 'blur' }]
      }
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.getGoodsList()
  },

  methods: {
    addShopBut() {
      this.$router.push({
        path: '/addShop'
      })
    },
    // 新增规格
    addUnitBut(row) {
      this.unitDialog = true
      this.shopRow = row
    },
    // 规格编辑
    unitEditBut(row) {
      this.unitRow = row
      this.unitDialog = true
      this.formUnit.name = row.name
      this.formUnit.price = row.price
      this.formUnit.stock = row.stock
    },
    // 规格删除
    unitDelBut(row) {
      apiDelPointsUnit({
        id: row.id
      }).then(res => {
        if (res.status === 0) {
          this.$Ms(res.msg)
          this.getGoodsList()
        } else if (res.status === 1) {
          this.$Me(res.msg)
        }
      })
    },

    // 规格弹窗确定
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 不为空表示编辑
          if (this.unitRow !== '') {
            apiEditPointsUnit({
              id: this.unitRow.id,
              name: this.formUnit.name,
              price: this.formUnit.price,
              stock: this.formUnit.stock
            }).then(res => {
              if (res.status === 0) {
                this.$Ms(res.msg)
                this.formUnit = {
                  name: '',
                  price: '',
                  stock: ''
                }
                this.unitDialog = false
                this.getGoodsList()
              } else if (res.status === 1) {
                this.$Me(res.msg)
              }
            })
          } else {
            apiAddPointsUnit({
              mid: this.shopRow.id,
              name: this.formUnit.name,
              price: this.formUnit.price,
              stock: this.formUnit.stock
            }).then(res => {
              if (res.status === 0) {
                this.$Ms(res.msg)
                this.formUnit = {
                  name: '',
                  price: '',
                  stock: ''
                }
                this.unitDialog = false
                this.getGoodsList()
              } else if (res.status === 1) {
                this.$Me(res.msg)
              }
            })
          }
        }
      })
    },
    // 弹窗关闭回调
    dialogClosed() {
      console.log(11)
      this.unitRow = ''
    },
    // 编辑
    editBut(row) {
      this.$router.push({
        path: '/addShop',
        query: {
          info: this.$Base64.encode(JSON.stringify(row))
        }
      })
    },
    // 删除
    delBut(row) {
      apiDeleteGoods({
        id: row.id
      }).then(res => {
        if (res.status === 0) {
          this.$Ms(res.msg)
          this.getGoodsList()
        } else if (res.status === 1) {
          this.$Me(res.msg)
        }
      })
    },

    // 获取积分商城的商品列表
    getGoodsList() {
      apiGetGoodsList().then(res => {
        if (res.status === 0) {
          // 将规格中的第一个价格当展示价格--map实现计算总库存
          this.ProductList = res.data.map(item => {
            item.allStock = 0
            if (item.pointsMallUnits.length !== 0) {
              item.price = item.pointsMallUnits[0].price
              item.pointsMallUnits.map(row => {
                if (row.stock > 0) {
                  item.allStock = item.allStock + row.stock
                }
              })
            }
            return item
          })
          this.ProductList.reverse()
          // this.ProductList = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.FZ0875 {
  font-size: 0.875em;
}
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    justify-content: space-between;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
    .el-button {
      margin: 10px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /deep/ .el-table .warning-row {
      background: oldlace;
    }
    /deep/ .el-table__expanded-cell {
      background: #f0f9eb;
    }
    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    /deep/ .specs-list {
      .name {
        width: 20%;
      }
      .data-right {
        width: 20%;
      }
    }
  }
}
.dialog {
  .content {
    .el-form {
      /deep/ .el-form-item__content {
        input {
          text-align: left;
        }
      }
    }
  }
}
</style>
